module.exports = __webpack_public_path__ + "img/foreground-circuit-01.918301a6.svg";